
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconPrinterSelector = "fhi-icon-printer";

/**
 * ## FhiIconPrinter
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-printer
 * @element fhi-icon-printer
 */
@customElement(FhiIconPrinterSelector)
export class FhiIconPrinter extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M17.25 15a.25.25 0 0 0-.25-.25H7a.25.25 0 0 0-.25.25v6c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25zm1.5 2.25H20A1.25 1.25 0 0 0 21.25 16v-5A1.25 1.25 0 0 0 20 9.75H4A1.25 1.25 0 0 0 2.75 11v5A1.25 1.25 0 0 0 4 17.25h1.25V15c0-.966.784-1.75 1.75-1.75h10c.966 0 1.75.784 1.75 1.75zM17.25 3a.25.25 0 0 0-.201-.245L17 2.75H7a.25.25 0 0 0-.25.25v5.25h10.5zm1.5 5.25H20A2.75 2.75 0 0 1 22.75 11v5A2.75 2.75 0 0 1 20 18.75h-1.25V21A1.75 1.75 0 0 1 17 22.75H7A1.75 1.75 0 0 1 5.25 21v-2.25H4A2.75 2.75 0 0 1 1.25 16v-5A2.75 2.75 0 0 1 4 8.25h1.25V3A1.75 1.75 0 0 1 7 1.25h10l.173.009A1.75 1.75 0 0 1 18.75 3z"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
